import React, { useContext, useState, useEffect } from "react";
import Logo from "../../../images/logo.png"
import SMLogo from "../../../images/sm-logo.png"
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";;

export function  NavMenuToggle(){
    setTimeout(()=>{	
      let mainwrapper = document.querySelector("#main-wrapper");
      if(mainwrapper.classList.contains('menu-toggle')){
        mainwrapper.classList.remove("menu-toggle");
      }else{
        mainwrapper.classList.add("menu-toggle");
      }
    },200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(true);
  const [logoLoadError, setLogoLoadError] = useState(false);
  const { navigationHader, openMenuToggle, background, companyLogo } = useContext(
    ThemeContext
  );

  useEffect(() => {
    // Reset error when company logo updates in store
    if (companyLogo) {
      setLogoLoadError(false);
    }
  }, [companyLogo]);

  const handleImageError = () => {
    setLogoLoadError(true);
  };

  return (
    <div className="nav-header">
      
      <Link to="/dashboard" className="brand-logo">
          {companyLogo && !logoLoadError ? (
            <>
             <img 
               src={companyLogo} 
               alt="logo" 
               className="img-fluid lg-logo"
               onError={handleImageError}
             />
             <img 
               src={companyLogo} 
               alt="logo" 
               className="img-fluid sm-logo"
               onError={handleImageError}
             />
            </>
          ) : (
            <>
              <img src={Logo} alt="logo" className="img-fluid lg-logo" />
              <img src={SMLogo} alt="logo" className="img-fluid sm-logo" />
            </>
          )}
         
      </Link>

      <div
          className="nav-control"
          onClick={() => {
              setToggle(!toggle);
               openMenuToggle();
               NavMenuToggle();
               //SideBarOverlay();
          }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
            <span className="line"></span><span className="line"></span><span className="line"></span>
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="22" y="11" width="4" height="4" rx="2" fill="#2A353A"/>
              <rect x="11" width="4" height="4" rx="2" fill="#2A353A"/>
              <rect x="22" width="4" height="4" rx="2" fill="#2A353A"/>
              <rect x="11" y="11" width="4" height="4" rx="2" fill="#2A353A"/>
              <rect x="11" y="22" width="4" height="4" rx="2" fill="#2A353A"/>
              <rect width="4" height="4" rx="2" fill="#2A353A"/>
              <rect y="11" width="4" height="4" rx="2" fill="#2A353A"/>
              <rect x="22" y="22" width="4" height="4" rx="2" fill="#2A353A"/>
              <rect y="22" width="4" height="4" rx="2" fill="#2A353A"/>
            </svg>	
        </div>
      </div>
    </div>
  );
};

export default NavHader;
